import { useContext } from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';

import { ptBR } from '@material-ui/core/locale';
import { createMuiTheme } from '@material-ui/core/styles';

import { CSSProp, ThemeContext } from 'styled-components';

export const MuiTheme = createMuiTheme(
  {
    palette: {
      primary: {
        light: '#358cc1',
        main: '#0370B2',
        dark: '#024E7C',
      },
      secondary: {
        light: '#56BF62',
        main: '#2CB03B',
        dark: '#379442',
      },
      error: {
        light: '#EA605D',
        main: '#E53935',
        dark: '#B22F2D',
      },
    },
    typography: {
      fontFamily: ['Roboto', 'sans-serif'].join(','),
      h1: {
        fontFamily: 'Proxima Nova',
      },
    },
  },
  ptBR,
);

export const theme = {
  ...MuiTheme,
  palette: {
    ...MuiTheme.palette,
    typographyColor: '#454545',
    red: '#ef1d15',
    blue: '#45a9ff',
    inherit: {
      light: '#FDFDFD',
      main: '#FDFDFD',
      dark: '#A0A0A0',
    },
    default: {
      light: '#FDFDFD',
      main: '#A0A0A0',
      dark: '#858585',
    },
    warning: {
      light: '#FFD278',
      main: '#FAB42A',
      dark: '#EEA617',
    },
    info: {
      light: '#CAD9FA',
      main: '#ACC4F9',
      dark: '#8195C1',
    },
    success: {
      light: '#96C267',
      main: '#7CB342',
      dark: '#567D2E',
    },
    background: {
      ...MuiTheme.palette.background,
      contrast: '#F5F7FB',
    },
  },
  notBroken: null,
};

export function useStyledTheme() {
  return useContext(ThemeContext);
}

export type ITheme = typeof theme;

declare module 'styled-components' {
  export interface DefaultTheme extends ITheme {
    notBroken: unknown;
  }
}

declare module 'react' {
  interface Attributes {
    css?: CSSProp;
  }
}
